import {
	API_START,
	API_END,
	FETCH_GET_LIVE_EVENTS,
	SET_LIVE_EVENTS,
	WS_EVENT,
	WS_CONNECTED,
	LIVE,
	LIVE_UPDATE,
	LIVE_DELETE,
	RESET_DATA,
	LIVE_ON_TOP,
	SET_DELETE_LIVE_EVENT_RESULT,
	SET_INTERESTED_LIVE_EVENT_RESULT,
	SET_UNINTERESTED_LIVE_EVENT_RESULT,
	SET_FILTER,
	DISPLAY_ALL,
	DISPLAY_ONLY_MY_POSTS,
	DISPLAY_ONLY_COMMUNITY_POSTS,
	SET_PROFILE_DETAILS,
	LIVE_INTERESTED,
	LIVE_UNINTERESTED,
	NAVIGATION,
	SET_DISPLAY_FILTER_OPTION,
	LIVE_REFRESH,
	SET_FEED_UNSEEN_COUNT
} from "../actions/types";
import { GROUP_ID_ACTIVITY, GROUP_ID_PROPOSAL } from "../config/constants";
import merge from "lodash/merge";
import { event } from "../actions/live";
import { normalize } from "normalizr";

const initialState = {
	isFetching: true,
	inLiveScreen: false,
	liveOnTop: true,
	cptNewEvents: 0,
	reload: 0,
	refresh: 0,
	page: 1,
	hasNextPage: false,
	nextPage: 2,
	totalPages: 0,
	totalDocs: 0,
	events: {},
	users: {},
	interestedusers: {},
	displayFilterOptions: false,
	filter: DISPLAY_ALL,
	user: null
};

export default function liveReducer(state = initialState, action = {}) {
	switch (action.type) {
		case API_START:
			if (action.payload === FETCH_GET_LIVE_EVENTS) {
				return {
					...state,
					isFetching: true
				};
			}
			break;

		case RESET_DATA:
			return {
				...initialState
			};

		case SET_FILTER:
			// We reinitialize a part of the state
			return {
				...state,
				reload: 0,
				page: 1,
				hasNextPage: false,
				nextPage: 2,
				totalPages: 0,
				totalDocs: 0,
				events: {},
				users: {},
				interestedusers: {},
				filter: action.payload
			};

		case SET_DISPLAY_FILTER_OPTION:
			return {
				...state,
				displayFilterOptions: action.payload
			};

		case SET_PROFILE_DETAILS: {
			const { _id, photoUri, firstname } = action.payload;
			const interestedusers = { ...state.interestedusers };
			interestedusers[_id] = { _id, photoUri, firstname };
			return {
				...state,
				userId: _id,
				interestedusers
			};
		}

		case WS_CONNECTED:
			return {
				...state,
				reload: ++state.reload
			};

		case LIVE_REFRESH:
			return {
				...state,
				refresh: ++state.refresh
			};

		case SET_LIVE_EVENTS: {
			const { events, users, interestedusers, infospages } = action.entities;
			const { page, hasNextPage, totalPages, totalDocs } = infospages["1"];

			if (page === 1) {
				return {
					...state,
					events: events ?? {},
					users: users ?? {},
					interestedusers: interestedusers ?? {},
					page,
					nextPage: 1 + page,
					hasNextPage,
					totalPages,
					totalDocs
				};
			} else {
				return merge({}, state, {
					events,
					users,
					interestedusers,
					page,
					nextPage: 1 + page,
					hasNextPage,
					totalPages,
					totalDocs
				});
			}
		}

		case LIVE_ON_TOP:
			return {
				...state,
				liveOnTop: action.value,
				cptNewEvents: action.value ? 0 : state.cptNewEvents
			};

		case NAVIGATION:
			if (
				action.name === "TabScreen" ||
				action.name === "LiveScreen" ||
				action.name === "LiveScreens"
			) {
				return {
					...state,
					inLiveScreen: true,
					cptNewEvents: state.liveOnTop ? 0 : state.cptNewEvents
				};
			} else {
				return {
					...state,
					inLiveScreen: false
				};
			}

		case WS_EVENT: {
			if (action.payload.type === LIVE) {
				// manage filter
				if (
					(state.filter === DISPLAY_ONLY_MY_POSTS &&
						action.payload.userId._id !== state.userId) ||
					(state.filter === DISPLAY_ONLY_COMMUNITY_POSTS &&
						(action.payload.groupId === GROUP_ID_ACTIVITY ||
							action.payload.groupId === GROUP_ID_PROPOSAL))
				) {
					// ignore event
					break;
				}
				const normalized = normalize(action.payload, event);
				const {
					users = {},
					interestedusers = {},
					events = {}
				} = normalized.entities;
				if (action.payload.groupId === "weather") {
					const others = { ...state.events };
					delete others[Object.keys(events)[0]];
					return {
						...state,
						events: {
							...events,
							...others
						}
					};
					// return { ...state, events };
				}

				const wsLiveEventId = Object.keys(events)[0];
				const wsLiveEvent = events[wsLiveEventId];
				const wsEventId = wsLiveEvent?.eventId;
				// Only publications shared by several communities (eventId) can
				// update an existing item: LiveEvents without eventId are always new
				const existingLiveEventId = wsEventId?._id
					? Object.keys(state.events).find(
							id => state.events[id]?.eventId?._id === wsEventId._id
					  )
					: undefined;
				const isUpdate = Boolean(existingLiveEventId);

				// If WS payload updates an existing publication, we patch it in place.
				// This prevents creating a duplicated live item for the same eventId.
				const nextEvents = isUpdate
					? {
							...state.events,
							[existingLiveEventId]: {
								...state.events[existingLiveEventId],
								...wsLiveEvent,
								_id: existingLiveEventId
							}
					  }
					: merge({}, events, state.events);

				return {
					...state,
					users: merge({}, users, state.users),
					interestedusers: merge({}, interestedusers, state.interestedusers),
					events: nextEvents,
					cptNewEvents: isUpdate
						? state.cptNewEvents
						: state.inLiveScreen && state.liveOnTop
						? 0
						: state.cptNewEvents + 1
				};
			} else if (action.payload.type === LIVE_DELETE) {
				// Copy + delete rather than `const { [id]: _, ...rest } = obj`: the
				// web Babel build compiles that computed-key rest pattern without
				// ever assigning the key, so nothing was removed.
				const events = { ...state.events };
				delete events[action.payload.id];
				// When a record is removed, we stay in the same page
				return {
					...state,
					nextPage: state.page,
					events
				};
			} else if (action.payload.type === LIVE_INTERESTED) {
				const { eventId, interestedUsersIds, user } = action.payload;

				const liveEvent =
					state.events[eventId] ||
					Object.values(state.events).find(
						event => event.eventId?._id === eventId
					);
				if (liveEvent) {
					const events = { ...state.events };
					events[liveEvent._id] = liveEvent;
					events[liveEvent._id].interestedUsersIds = interestedUsersIds;
					const interestedusers = { ...state.interestedusers };
					interestedusers[user._id] = user;
					return { ...state, events, interestedusers };
				}
			} else if (action.payload.type === LIVE_UNINTERESTED) {
				const { eventId, interestedUsersIds } = action.payload;

				const liveEvent =
					state.events[eventId] ||
					Object.values(state.events).find(
						event => event.eventId?._id === eventId
					);
				if (liveEvent) {
					const events = { ...state.events };
					liveEvent.interestedUsersIds = interestedUsersIds;
					const interestedusers = {};
					Object.assign(interestedusers, state.interestedusers);
					return {
						...state,
						events,
						interestedusers
					};
				}
			}
			break;
		}

		case SET_INTERESTED_LIVE_EVENT_RESULT:
		case SET_UNINTERESTED_LIVE_EVENT_RESULT: {
			if (state.events[action.payload._id]) {
				const events = { ...state.events };
				events[action.payload._id].interestedUsersIds =
					action.payload.interestedUsersIds;
				return {
					...state,
					events
				};
			}
			break;
		}

		case API_END:
			if (action.payload === FETCH_GET_LIVE_EVENTS) {
				return {
					...state,
					isFetching: false
				};
			}
			break;

		case SET_DELETE_LIVE_EVENT_RESULT: {
			// Client-authoritative removal on HTTP success. See the comment in
			// actions/live.js — mirrors the WS_LIVE_DELETE case above so the
			// deleter's UI updates even when their own socket does not deliver
			// the fan-out broadcast (paused PWA tab, closed WS, etc.).
			if (!action.id) return state;
			// Copy + delete: see the LIVE_DELETE case above.
			const events = { ...state.events };
			delete events[action.id];
			return {
				...state,
				nextPage: state.page,
				events
			};
		}

		case SET_FEED_UNSEEN_COUNT:
			// Server-authoritative value returned by GET /events/unseen-count and
			// POST /events/seen. Feeds both the LiveTab badge and the app icon
			// badge on web (see PushNotifications.web.jsx).
			return {
				...state,
				cptNewEvents:
					typeof action.payload?.unseen === "number"
						? action.payload.unseen
						: state.cptNewEvents
			};

		default:
			return state;
	}
	return state;
}
